module.exports = __webpack_public_path__ + "media/reportAssets/barriers-9b3d2825.jpg";